import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [provideBrowserGlobalErrorListeners(),
  provideRouter(routes),
  provideHttpClient(
    withInterceptorsFromDi(),
  ),
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
  ],
};
